import React, { PureComponent, createRef } from 'react';

type Props = {
  videoUrl: string;
  poster?: string;
  showControls?: boolean;
  autoPlay?: boolean;
  preload?: boolean;
  loop?: boolean;
  mute?: boolean;
  onStartedPlaying?: () => void;
  width: string | number;
  className?: string;
};

class Video extends PureComponent<Props> {
  videoRef: React.RefObject<HTMLVideoElement> = createRef();

  static defaultProps = {
    showControls: false,
    autoPlay: false,
    preload: true,
    loop: true,
    mute: true,
    width: '100%',
  };

  componentDidMount() {
    // Fixes react bug where "muted" HTML attribute is removed by react-dom. (7/6/2018)
    // https://github.com/facebook/react/issues/10389

    // Required for autoplay on chrome
    // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes (6/6/2018)
    if (this.videoRef.current && this.props.mute) {
      this.videoRef.current.setAttribute('muted', '1');
    }
  }

  play() {
    if (this.videoRef.current) {
      this.videoRef.current.play();
    }
  }

  pause() {
    if (this.videoRef.current) {
      this.videoRef.current.pause();
    }
  }

  render() {
    const {
      videoUrl,
      poster,
      showControls,
      autoPlay,
      preload,
      loop,
      mute,
      width,
      onStartedPlaying,
      className,
    } = this.props;
    const autoPlayProp = autoPlay ? { autoPlay: true } : {};
    return (
      <video
        ref={this.videoRef}
        key={videoUrl}
        poster={poster}
        width={width}
        onPlaying={onStartedPlaying}
        controls={showControls}
        controlsList="nodownload" // don't show download button on previews
        muted={mute}
        loop={loop}
        className={className}
        {...autoPlayProp}
        preload={preload ? 'auto' : 'none'}
        // React 17+ has proper support for disableRemotePlayback.
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        disableremoteplayback="true"
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
    );
  }
}

export default Video;
